<template>
  <div class="not_found">
    <div class="not_found_content">
      <div class="not_found_title">
        暂无数据
      </div>
      <van-button block type="info" class="btn" native-type="submit" @click="login">账号登录</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    login() {
      this.$router.push('/login')
    }
  },
}
</script>
<style lang="less" scoped>
.not_found {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  text-align: center;

  .btn {
    background-color: rgba(43, 70, 138, 1);
    color: #fff;
    font-size: 0.14rem;
    text-align: center;
    font-family: Roboto;
    border-radius: 8px;
  }

  .not_found_content {
    margin-top: 50%;

    .not_found_title {
      margin-bottom: 20px;
      font-size: 0.16rem
    }
  }
}
</style>